import { Box } from '@chakra-ui/react';

import { MarkdownRenderer } from './MarkdownRenderer';

type VAlign = 'start' | 'center' | 'end';

const VALIGN_TO_JUSTIFY: Record<VAlign, string> = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
};

interface TextChartContentProps {
  content: string | null;
  color?: string;
  vAlign?: VAlign;
  isGlobalAiChartPreview?: boolean;
}

const GLOBAL_AI_ASSISTANT_TEXT_COLOR = '#2D426A';

export const TextChartContent = ({
  content,
  color,
  vAlign = 'start',
  isGlobalAiChartPreview = false,
}: TextChartContentProps) => (
  <Box
    {...(isGlobalAiChartPreview
      ? {
          h: 'auto',
          minH: 'min-content',
          overflow: 'visible',
        }
      : {
          height: '100%',
          overflow: 'hidden',
        })}
    display="flex"
    flexDirection="column"
    justifyContent={VALIGN_TO_JUSTIFY[vAlign]}
  >
    <Box
      width="100%"
      {...(isGlobalAiChartPreview
        ? { h: 'auto', minH: 'min-content' }
        : { height: '100%' })}
      color={
        isGlobalAiChartPreview
          ? (color ?? GLOBAL_AI_ASSISTANT_TEXT_COLOR)
          : (color ?? 'text.primary')
      }
      {...(isGlobalAiChartPreview ? {} : { paddingX: '0.5rem' })}
    >
      <MarkdownRenderer
        content={content}
        variant={isGlobalAiChartPreview ? 'assistant' : 'default'}
      />
    </Box>
  </Box>
);
